import {
  Grid,
  Typography,
  Divider,
  Box,
  Paper,
} from "@mui/material";
import { useIntl } from "react-intl";
import DinamicTable from "components/DinamicTable/DinamicTable";
import { Spinner } from "react-bootstrap";

interface Cotizaciones {
  id: number;
}

interface DetalleCotizacionProps {
  verCotizaciones?: Cotizaciones[] | null;
  procesando?: boolean;
  handleisAlertOpenDetalleCotizacion: () => void;
  getCotizacionPorId: (datos: any) => Promise<void>;
  onVerBitacora: (idCotizacion: number) => void;
}

const CotizacionesModulo = ({
  verCotizaciones,
  procesando,
  handleisAlertOpenDetalleCotizacion,
  getCotizacionPorId,
  onVerBitacora
}: DetalleCotizacionProps) => {
  const intl = useIntl();

  if (!verCotizaciones) return null;

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        {/* Información de la cotizacion */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              <Grid item xs={12} md={9}>
                <Typography variant="h6" color="primary" gutterBottom sx={{ color: "#004c93", textAlign: "left" }}>
                  Cotizaciones registradas
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {verCotizaciones.length > 0 ? (
              <>
                <DinamicTable
                  key={"tabla"}
                  sinExport
                  canSearch
                  columnsOrder={[
                    "id",
                    "total_proveedores",
                    "proveedores_respondidos",
                    "proveedores_pendientes",
                    "estatus_cotizacion",
                  ]}
                  data={verCotizaciones}
                  esListaCotizaciones
                  actions
                  enAccion={(accion, row) => {
                    if (accion === "ver") {
                      const datos = {
                        id_cotizacion: row?.id,
                      };
                      getCotizacionPorId(datos);
                      handleisAlertOpenDetalleCotizacion();
                    }
                    if (accion === "ver_bitacora") {
                      onVerBitacora(row?.id);
                    }
                  }}
                />
              </>
            ) : procesando ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "general_cargando_datos" })}
                </Typography>
                <Spinner animation="border" />
              </Box>
            ) : verCotizaciones?.length === 0 && !procesando ? (
              <Box sx={{ textAlign: "center", py: 2 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "no_hay_datos_registrados" })}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default CotizacionesModulo;
